import { useQuery } from 'react-query';
import { model as clientProgressModel, WidgetHistoryWeek } from '../progress';

export const widgetHistoryQueryKey = (clientId, widgetId) => ['client', clientId, 'widget', widgetId, 'history'];

export const useWidgetHistory = (clientId, widgetId) =>
  useQuery<WidgetHistoryWeek[]>(widgetHistoryQueryKey(clientId, widgetId), () =>
    clientProgressModel(clientId).getWidgetHistory(widgetId),
  );
